import React from 'react';
import './PlanOutlineButtons.css';
import '../../colors.css';
import osisConverters from '../../utilities/osisConversions';

const PlanOutlineButtons = (props) => {
    let content = props;
    let osisRange = "";
    const applicationQuestions = props.applicationQuestions;
    const comprehensionQuestions = props.comprehensionQuestions;
    const commentary = props.commentary;
    const application = props.application;
    const meditation = props.meditation;
    const crossReferences = props.crossReferences;
    const devotional = props.devotional;

    if (!content)
        content = "Undefined!"

    // console.log('osisRangeIn: ', osisRange)
    
    if (typeof content === "string")
        osisRange = content;
    else if (content.osisRange)
        osisRange = content.osisRange;
    else if (content.ref)
        osisRange = content.ref;

    osisRange = osisConverters.formatOsisRange(osisRange);

    const colorIndex = props.colorIndex || 0;
    const {
        osisBookStart,
        osisBookEnd,
        osisChapterStart,
        osisChapterEnd,
        osisVerseStart,
        osisVerseEnd,
    } = osisConverters.deconstructOsisRange(osisRange);

    let title= osisBookStart + " " + osisChapterStart + "." + osisVerseStart + "-" + osisChapterEnd + "." + osisVerseEnd;

    if (!osisVerseStart)
    {
        if (osisChapterEnd === osisChapterStart)
            title = osisBookStart + " " + osisChapterStart;
        else
            title = osisBookStart + " " + osisChapterStart + "-" + osisChapterEnd;
    }

    if ((osisChapterEnd == osisChapterStart)&&(osisVerseEnd == osisVerseStart))
    {
        title = osisBookStart + " " + osisChapterStart + "." + osisVerseStart;
    }

    if (content.title)
        title = content.title;

    title = title.replace('.',':').replace('.',':');

    if (props.index)
        title = props.index + ". " + title;

    let href= window.getVerseURL(osisRange);

    if (href)
    {
        let url = new URL("https://www.ai-bible.com");

        if (devotional)
            url.searchParams.append('dev', JSON.stringify(devotional))
        else
        {
            if (applicationQuestions)
                url.searchParams.append('aq', JSON.stringify(applicationQuestions))

            if (comprehensionQuestions)
                url.searchParams.append('cq', JSON.stringify(comprehensionQuestions))

            if (commentary)
                url.searchParams.append('c', commentary)

            if (application)
                url.searchParams.append('a', application)

            if (meditation)
                url.searchParams.append('m', meditation)

            if (crossReferences)
                url.searchParams.append('cr', JSON.stringify(crossReferences))
        }

        //href = `/reader?verse=${osisRange}`;

        //url is of this format as links work differently on web vs mobile and so different handlijng
        //return (window.web_version)?`/read/${verse}`:`/reader?verse=${verse}`;
        if (window.web_version) {
            const destination = new URL(href, window.location.origin);
            const extraParams = new URLSearchParams(url.search);
            extraParams.forEach((value, key) => destination.searchParams.set(key, value));
            href = `${destination.pathname}${destination.search}${destination.hash}`;
        }
        else
        {
            const temphref = url.href.replace('?','')
            //console.log('chref', href, url.href, temphref)
            href = temphref.replace("https://www.ai-bible.com/", href + "&");
        }
    }

    if (content.href)
    {
        href = content.href;
    }

    // console.log("Outline Button: ", title, href, devotional)
    
    return (
        <div className="outline-buttons">
            <a
                className={`color-${colorIndex} outline-button`}
                href={href}
                target={ (window.web_version)?"_blank":"_parent" } 
                onClick={() => { console.log('VerseButton: Click: ', osisRange, href); }}
            >
                <p className="outline-button-text">
                    {title}
                </p>
            </a>
        </div>
    );
 
};

export default PlanOutlineButtons;
